import * as storeTypes from './company.store-types';
import axios from 'axios';
import {Company} from './models/company.models';
import {User} from '../user/models/user.models';
import {UserGroup} from '../user/modules/user-groups/user-group.models';
import {OvpJobCondition} from '../ovp/models/ovp-job-condition.models';
import {JobTitle} from './modules/job-titles/job-title.models';

export default {
    namespaced: true,
    state: {
        isLoading: false,
        isActiveRequest: false,
        companies: [],
        currentCompany: new Company,
    },
    mutations: {
        [storeTypes.SET_COMPANIES]: (state, companies) => state.companies = companies,
        [storeTypes.SET_CURRENT_COMPANY_USERS]: (state, users) => state.currentCompany.users = users.map(user => User.fromArray(user)),
        [storeTypes.SET_CURRENT_COMPANY_USERS_GROUPS]: (state, usersGroups) => state.currentCompany.usersGroups = usersGroups.map(userGroup => UserGroup.fromArray(userGroup)),
        [storeTypes.SET_CURRENT_COMPANY_OVP_JOB_CONDITIONS]: (state, ovpJobConditions) => state.currentCompany.ovpJobConditions = ovpJobConditions.map(ovpJobCondition => OvpJobCondition.fromArray(ovpJobCondition)),
        [storeTypes.SET_CURRENT_COMPANY_JOB_TITLES]: (state, jobTitles) => state.currentCompany.jobTitles = jobTitles.map(jobTitle => JobTitle.fromArray(jobTitle)),
        [storeTypes.SET_CURRENT_COMPANY]: (state, currentCompany) => state.currentCompany = currentCompany,
        [storeTypes.SET_IS_LOADING]: (state, isLoading) => state.isLoading = isLoading,
        [storeTypes.SET_IS_ACTIVE_REQUEST]: (state, isActiveRequest) => state.isActiveRequest = isActiveRequest,
    },
    actions: {
        async [storeTypes.ACTION_GET_COMPANIES](store, name = '') {
            store.commit(storeTypes.SET_IS_LOADING, true);

      return new Promise((resolve, reject) => {
        (async () => {
          try {
            const {
              data: {success, error, companies}
            } = await axios.get(`/api/companies?name=${name}`);

            if (!success) {
              return reject(error);
            }

            store.commit(
                storeTypes.SET_COMPANIES,
                companies.map(company => Company.fromArray(company))
            );
            resolve();
          } catch ({
            response: {
              data: {error}
            }
          }) {
            reject(error);
          } finally {
            store.commit(storeTypes.SET_IS_LOADING, false);
          }
        })();
      });
    },
    async [storeTypes.ACTION_GET_SINGLE_COMPANY](store, companyId) {
      store.commit(storeTypes.SET_IS_LOADING, true);

      return new Promise((resolve, reject) => {
        (async () => {
          try {
            const {
              data: {success, error, company}
            } = await axios.get(`/api/companies/${companyId}`);

            if (!success) {
              return reject(error);
            }

            store.commit(
                storeTypes.SET_CURRENT_COMPANY,
                Company.fromArray(company)
            );
            resolve(store.state.currentCompany);
          } catch ({
            response: {
              data: {error}
            }
          }) {
            reject(error);
          } finally {
            store.commit(storeTypes.SET_IS_LOADING, false);
          }
        })();
      });
    },
    async [storeTypes.ACTION_CREATE_COMPANY](store, company) {
      store.commit(storeTypes.SET_IS_ACTIVE_REQUEST, true);

      return new Promise((resolve, reject) => {
        (async () => {
          try {
            const {
              data: {success}
            } = await axios.post("/api/companies", company);

            if (success) {
              return resolve();
            }
          } catch ({
            response: {
              data: {error}
            }
          }) {
            reject(error);
          } finally {
            store.commit(storeTypes.SET_IS_ACTIVE_REQUEST, false);
          }
        })();
      });
    },
    async [storeTypes.ACTION_UPDATE_COMPANY](store, company) {
      store.commit(storeTypes.SET_IS_ACTIVE_REQUEST, true);

      return new Promise((resolve, reject) => {
        (async () => {
          try {
            const {
              data: {success}
            } = await axios.put(`/api/companies/${company._id}`, company);

            if (success) {
              return resolve();
            }
          } catch ({
            response: {
              data: {error}
            }
          }) {
            reject(error);
          } finally {
            store.commit(storeTypes.SET_IS_ACTIVE_REQUEST, false);
          }
        })();
      });
    },
    async [storeTypes.ACTION_REMOVE_COMPANY](store, companyId) {
      store.commit(storeTypes.SET_IS_ACTIVE_REQUEST, true);

      return new Promise((resolve, reject) => {
        (async () => {
          try {
            const {
              data: {success}
            } = await axios.delete(`/api/companies/${companyId}`);

            if (success) {
              return resolve();
            }
          } catch ({
            response: {
              data: {error}
            }
          }) {
            reject(error);
          } finally {
            store.commit(storeTypes.SET_IS_ACTIVE_REQUEST, false);
          }
        })();
      });
    },
  },
  getters: {
    [storeTypes.GET_COMPANIES]: state => state.companies,
    [storeTypes.GET_CURRENT_COMPANY]: state => state.currentCompany,
    [storeTypes.GET_CURRENT_COMPANY_MANAGERS]: state => state.currentCompany.users.filter(user => user.role == "manager"),
    [storeTypes.GET_IS_LOADING]: state => state.isLoading,
    [storeTypes.GET_IS_ACTIVE_REQUEST]: state => state.isActiveRequest,
  }
};